
const DialogType = {
    CLIENTE:                0,
    QUERY_CLIENTES:         1,
    SELECCIONAR_CLIENTE:    2,
    PLAN:                   3,
    QUERY_PLANES:           4,
    ITEM:                   5,
    QUERY_ITEMS:            6,
    CONTRATO:               7,
    QUERY_CONTRATOS:        8,
    SERVICIO:               9,
    QUERY_SERVICIOS:       10,
    ZONA:                  11,
    QUERY_ZONAS:           12,
};

const ModosOp = {
    CREAR: 0,     //La operacion va usar la data en los campos ("data actual") para crear una entidad
    MODIFICAR: 1, //La operacion va usar La data en los campos ("data actual") para modificar una entidad
    OK: 2 //La operacion va dejar de mostrar la data en los campos ("data actual") de una entidad
};


export { DialogType, ModosOp};
